import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import {
  HeaderH2,
  HeaderH1,
  Text,
  NextButton,
  ImageBlock,
} from "components/TextBlocks";

function SaveTabs(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Save images</HeaderH1>
      <Text>
        To save an image, simply right-click on an image on any website and select "Save image:", followed by choosing which category and group you want to save it to.
      </Text>
      <ImageBlock
        src={"/guide/save_image_right_click.png"}
        width={523}
        height={422}
        quality={100}
        alt={"Save image by right-click"}
      />
      <HeaderH2 id="Savealltabs">Add inside your dashboard</HeaderH2>
      <Text>
        You can also add images to your groups by choosing the "Add site/image" option in the group menu.
      </Text>
      <ImageBlock
        src={"/guide/add_site_image.png"}
        width={658}
        height={653}
        quality={100}
        alt={"Add site/image to group"}
      />
      <HeaderH2 id="Savealltabs">Important note about storage</HeaderH2>
      <Text>
        Please be aware that tabExtend only stores references to image URLs, not the actual image files. If an image is important to you and you don't control the website hosting it, we strongly recommend downloading a copy to your hard drive as well. This ensures you'll still have access to the image even if the original source becomes unavailable.
      </Text>
      <NextButton
        cta={"Create notes/to-dos"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/create-note"}
      />
    </>
  );
}

SaveTabs.Layout = SideBar;

export default SaveTabs;
